import React from 'react';

import { Typography as MuiTypography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { TypographyProps as MuiTypographyProps } from '@material-ui/core/Typography';
import clsx from 'clsx';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'body1'
  | 'body2'
  | 'body2-secondary'
  | 'caption'
  | 'button'
  | 'fineprint';

export interface TypographyProps extends Omit<MuiTypographyProps, 'variant'> {
  className?: string;
  variant?: TypographyVariant;
}

const useStyles = makeStyles((theme: Theme) => ({
  fineprint: {
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.2,
  },
  secondary: {
    color: theme.palette.grey[800],
  },
}));

export function Typography(props: TypographyProps): JSX.Element {
  const { children, className = '', variant = 'body1', ...rest } = props;

  const classes = useStyles();

  const fdStyleBody2Secondary =
    variant === 'body2-secondary' ? classes.secondary : null;
  const fdStyleFineprint = variant === 'fineprint' ? classes.fineprint : null;

  const typographyStyles = clsx(
    'fd-text',
    `fd-text__${variant}`,
    fdStyleBody2Secondary,
    fdStyleFineprint,
    className && className,
  );

  const getMuiVariant = (fdVariant) => {
    switch (fdVariant) {
      case 'body2-secondary':
        return 'body2';
      case 'fineprint':
        return 'body1';
      default:
        return fdVariant;
    }
  };

  return (
    <MuiTypography
      {...rest}
      className={typographyStyles}
      variant={getMuiVariant(variant)}
    >
      {children}
    </MuiTypography>
  );
}
